var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoFootPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 299.876,
    height: 328.639,
    viewBox: "0 0 299.876 328.639",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d600fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33003c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_19",
    "data-name": "\\uADF8\\uB8F9 19",
    transform: "translate(-370.019 -316.009)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD569\\uCE58\\uAE30_1",
    "data-name": "\\uD569\\uCE58\\uAE30 1",
    d: "M124.4-1523.516c-32.808-6.741-49.555-40.4-37.4-75.17s48.6-57.5,81.4-50.757c20.047,4.119,34.1,18.288,39.222,36.619,3.161-16.958,15.2-30.364,33.042-34.028,26.884-5.52,56.768,13.172,66.746,41.75s-3.727,56.219-30.612,61.739c-15.227,3.126-31.416-1.514-44.405-11.319a30.278,30.278,0,0,1-22.493,9.615,31.032,31.032,0,0,1-17.587-5.34c-14.236,17.282-35.251,28.075-56.138,28.076A58.419,58.419,0,0,1,124.4-1523.516Z",
    transform: "translate(329.096 2166.979)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_20",
    "data-name": "\\uD0C0\\uC6D0 20",
    cx: 34.5,
    cy: 79.736,
    rx: 34.5,
    ry: 79.736,
    transform: "matrix(0.921, -0.391, 0.391, 0.921, 398.363, 375.67)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_22",
    "data-name": "\\uD0C0\\uC6D0 22",
    cx: 29.924,
    cy: 29.642,
    rx: 29.924,
    ry: 29.642,
    transform: "matrix(0.719, -0.695, 0.695, 0.719, 370.019, 515.816)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_23",
    "data-name": "\\uD0C0\\uC6D0 23",
    cx: 32.424,
    cy: 32.642,
    rx: 32.424,
    ry: 32.642,
    transform: "matrix(0.875, 0.485, -0.485, 0.875, 613.178, 440.586)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_21",
    "data-name": "\\uD0C0\\uC6D0 21",
    cx: 41.55,
    cy: 89.113,
    rx: 41.55,
    ry: 89.113,
    transform: "translate(506.208 316.009) rotate(1)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFootPrint);
export default __webpack_public_path__ + "static/media/logo-foot-print.acd86ffadc4851283020714f656dd39c.svg";
export { ForwardRef as ReactComponent };